import * as React from 'react';
import styles from './Ny25Animation.scss';
import classNames from 'classnames';

interface INy25Animation {
    isDisableTransition?: boolean;
    children: React.ReactNode;
    isDisabled: boolean;
}

const Ny25Animation = ({ isDisabled, children, isDisableTransition }: INy25Animation) => {
    const classes = classNames(styles.animation, {
        [styles.withoutTransition]: isDisableTransition,
        [styles.disableAnimation]: isDisabled,
    });

    return (
        <>
            <div className={classes}>
                <span className={styles.layout2}></span>
                <span className={styles.layout5}></span>
                <span className={styles.layout1}></span>
                <span className={styles.layout3}></span>
                <span className={styles.layout4}></span>
            </div>
            {children}
        </>
    );
};

export default Ny25Animation;
